import {jwtDecode} from "jwt-decode";

export const getCurrentUserId = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.id || decoded._id; // depends on how you sign JWT
  } catch {
    return null;
  }
};
